import "@ungap/global-this";

import {
  ExitIntent,
  PageVisibility,
  UrlChange,
  ViewportScroll,
} from "./trackers";
import {
  ListenerTypes,
  activeHeartbeat,
  listener,
  onDocumentReady,
} from "./shared";
import {
  EventLoggerModule,
  TriggerContentModule,
  TriggerPreviewsModule,
  TriggersModule,
  VisualEditorModule,
} from "./modules";

const BattingCageScript = () => {
  const setupScript = () => {
    const { isVisualEditorMode } = VisualEditorModule.start();

    const { isPreviewingDomain } = TriggerPreviewsModule.start();

    const cookiesEnabled = navigator.cookieEnabled;

    const browserSupportsPageVisibilityApi = document.visibilityState;

    const browserSupportsScriptRequirements =
      cookiesEnabled && browserSupportsPageVisibilityApi;

    const shouldStartTriggerScript = !isPreviewingDomain || !isVisualEditorMode;

    const shouldStartPassiveMode = isPreviewingDomain;

    return {
      browserSupportsScriptRequirements,
      shouldStartTriggerScript,
      shouldStartPassiveMode,
    };
  };

  const startPassiveMode = () => {
    PageVisibility.start();

    listener.on(ListenerTypes.visibilityChange, (isPageHidden: boolean) => {
      TriggerPreviewsModule.updateBattingCageScriptPreviewCookieOnPageVisibilityChange(
        isPageHidden
      );

      if (isPageHidden) {
        EventLoggerModule.postEventLogsToAPI();
      }
    });
  };

  const setupTrackers = () => {
    ExitIntent.start();
    PageVisibility.start();
    /**  `activeHeartbeat`  needs to go after `PageVisibility` */
    activeHeartbeat.start();
    UrlChange.start();
    ViewportScroll.start();
  };

  const setupListeners = () => {
    listener.on(ListenerTypes.visibilityChange, (isPageHidden: boolean) => {
      TriggerPreviewsModule.updateBattingCageScriptPreviewCookieOnPageVisibilityChange(
        isPageHidden
      );

      TriggersModule.verifySessionIdCookeHasNotChangedOnPageVisibilityShow(
        isPageHidden
      );

      if (isPageHidden) {
        EventLoggerModule.postEventLogsToAPI();
      }
    });

    listener.on(ListenerTypes.urlChange, async () => {
      await TriggersModule.start();
      await TriggerContentModule.setPageContent();
    });
  };

  const setupTriggers = () => {
    TriggersModule.start();
  };

  return {
    start: () => {
      const {
        browserSupportsScriptRequirements,
        shouldStartTriggerScript,
        shouldStartPassiveMode,
      } = setupScript();

      if (browserSupportsScriptRequirements) {
        if (shouldStartPassiveMode) {
          startPassiveMode();
          return;
        }

        if (shouldStartTriggerScript) {
          setupTrackers();
          setupListeners();
          setupTriggers();
          return;
        }
      }
    },
  };
};

const battingCageScript = BattingCageScript();

onDocumentReady(battingCageScript.start);
